import { get, put } from "../request";

const PREFIX = "/courseAdmin/course/signup-audit";

/** 分页查询课程报名审核记录 */
export function getCourseSignupAuditPage(params) {
  return get(`${PREFIX}/page`, params);
}

/** 批量通过课程报名审核 */
export function approveCourseSignupAudit(data) {
  return put(`${PREFIX}/approve`, data);
}

/** 批量拒绝课程报名审核 */
export function rejectCourseSignupAudit(data) {
  return put(`${PREFIX}/reject`, data);
}



// WEBPACK FOOTER //
// ./src/api/course/signupAudit.js